import { Box, Heading } from '@wix/design-system'
import classNames from 'classnames'
import React, { FC, memo } from 'react'
import { useMediaQuery } from 'react-responsive'

import { LARGE_DESKTOP, SMALL_DESKTOP } from '../../../breakpoints'
import Arrow from '../icons/Arrow.svg'
import Logos from '../icons/Logos.svg'
import s from './VideoBox.scss'

type Props = {
  src: string
  backgroundColor?: string
  light?: boolean
  description?: string
  logos?: boolean
}

export const VideoBox: FC<Props> = memo(({ backgroundColor, src, description, light, logos = false }) => {
  const isLargeDesktopScreen = useMediaQuery(LARGE_DESKTOP)
  const isSmallDesktopScreen = useMediaQuery(SMALL_DESKTOP)

  return (
    <Box width="100%" backgroundColor={backgroundColor} verticalAlign="middle" align="center" direction="vertical">
      <Box width="75%" position="relative" direction="vertical">
        <video width="100%" src={src} loop={true} autoPlay={true} muted={true} />
        <Box gap="SP7" top={isSmallDesktopScreen ? '97%' : '100%'} direction="vertical">
          {description && (
            <Box gap="SP2">
              <Box width="40px" height="40px" position="relative" top="-15px" verticalAlign="middle" align="center">
                <Arrow stroke={light ? 'white' : 'black'} />
              </Box>
              <div>
                <Heading
                  size="medium"
                  className={classNames(s.description, { [s.descriptionLargeDesktop]: isLargeDesktopScreen })}
                  light={light}
                >
                  {description}
                </Heading>
              </div>
            </Box>
          )}
          {logos && <Logos width="100%" />}
        </Box>
      </Box>
    </Box>
  )
})
